(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7121],{

/***/ 6375:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _styles_countryadmissionsday_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(83157);
/* harmony import */ var _styles_countryadmissionsday_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_styles_countryadmissionsday_module_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react_bootstrap_Container__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(10682);
/* harmony import */ var react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(34051);
/* harmony import */ var react_bootstrap_Col__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(31555);
/* harmony import */ var _CustomImage__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(45992);
/* harmony import */ var react_slick__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(46066);
/* harmony import */ var slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(98322);
/* harmony import */ var slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(slick_carousel_slick_slick_css__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(98745);
/* harmony import */ var slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(slick_carousel_slick_slick_theme_css__WEBPACK_IMPORTED_MODULE_5__);










const PopularCourses = ({ coursedata  })=>{
    const sliderRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const settings = {
        infinite: true,
        arrows: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        rows: 3,
        slidesPerRow: 1,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dotsClass: (_styles_countryadmissionsday_module_scss__WEBPACK_IMPORTED_MODULE_6___default().sliderDots),
                    dots: true
                }
            }
        ]
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: (_styles_countryadmissionsday_module_scss__WEBPACK_IMPORTED_MODULE_6___default().popularcourses),
            style: {
                backgroundColor: coursedata?.sectionBgColor || "#FFF1EF"
            },
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Container__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (_styles_countryadmissionsday_module_scss__WEBPACK_IMPORTED_MODULE_6___default().heading),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                    children: coursedata?.sectionTitle
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Container__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (_styles_countryadmissionsday_module_scss__WEBPACK_IMPORTED_MODULE_6___default().popularCourseslider),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_slick__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                    ...settings,
                                    className: (_styles_countryadmissionsday_module_scss__WEBPACK_IMPORTED_MODULE_6___default().slider),
                                    ref: sliderRef,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Row__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
                                            children: coursedata?.pointImage?.length > 0 && coursedata?.pointImage?.map((offer, ind)=>{
                                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_bootstrap_Col__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
                                                    xl: 6,
                                                    lg: 6,
                                                    md: 6,
                                                    sm: 12,
                                                    xs: 6,
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: (_styles_countryadmissionsday_module_scss__WEBPACK_IMPORTED_MODULE_6___default().mainBox),
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                            className: (_styles_countryadmissionsday_module_scss__WEBPACK_IMPORTED_MODULE_6___default().box),
                                                            children: [
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    className: (_styles_countryadmissionsday_module_scss__WEBPACK_IMPORTED_MODULE_6___default().img),
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_CustomImage__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                                                        src: offer.imageUrl || "/images/admissionsday/popularstart.png",
                                                                        width: 60,
                                                                        height: 60,
                                                                        className: (_styles_countryadmissionsday_module_scss__WEBPACK_IMPORTED_MODULE_6___default().studImg),
                                                                        alt: "handshake.png"
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                                    className: (_styles_countryadmissionsday_module_scss__WEBPACK_IMPORTED_MODULE_6___default().para),
                                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("p", {
                                                                        children: [
                                                                            " ",
                                                                            offer?.title
                                                                        ]
                                                                    })
                                                                })
                                                            ]
                                                        })
                                                    })
                                                }, ind);
                                            })
                                        })
                                    })
                                })
                            })
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PopularCourses);


/***/ }),

/***/ 37121:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ ApplicationWeek_LandingPageComponent; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./components/AdmissionsDay/PopularCourses.tsx
var PopularCourses = __webpack_require__(6375);
// EXTERNAL MODULE: ./components/AdmissionsDay/WhyStudyinCountry.tsx
var WhyStudyinCountry = __webpack_require__(67962);
// EXTERNAL MODULE: ./components/AdmissionsDay/StudiesFAQ.tsx
var StudiesFAQ = __webpack_require__(26102);
// EXTERNAL MODULE: ./components/MetaTagsComp.tsx
var MetaTagsComp = __webpack_require__(47046);
// EXTERNAL MODULE: ./components/OverseasEdutionFair/eduFairStudTestimonials.tsx
var eduFairStudTestimonials = __webpack_require__(91071);
// EXTERNAL MODULE: ./components/OverseasEdutionFair/eduFairKcByNumber.tsx
var eduFairKcByNumber = __webpack_require__(17057);
// EXTERNAL MODULE: ./components/OverseasEdutionFair/eduFairWhyChoosekc.tsx
var eduFairWhyChoosekc = __webpack_require__(17477);
// EXTERNAL MODULE: ./components/OverseasEdutionFair/eduFairFooter.tsx
var eduFairFooter = __webpack_require__(74050);
// EXTERNAL MODULE: ./components/AdmissionsDay/BenefitsOfAdmissionsDay.tsx
var BenefitsOfAdmissionsDay = __webpack_require__(48664);
// EXTERNAL MODULE: ./components/OverseasEdutionFair/AccomplishSection.tsx
var AccomplishSection = __webpack_require__(79782);
// EXTERNAL MODULE: ./styles/applicationweek.module.scss
var applicationweek_module = __webpack_require__(76932);
var applicationweek_module_default = /*#__PURE__*/__webpack_require__.n(applicationweek_module);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Container.js
var Container = __webpack_require__(10682);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Row.js
var Row = __webpack_require__(34051);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Col.js
var Col = __webpack_require__(31555);
// EXTERNAL MODULE: ./components/CustomImage.tsx
var CustomImage = __webpack_require__(45992);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Nav.js + 3 modules
var Nav = __webpack_require__(80957);
// EXTERNAL MODULE: ./node_modules/react-bootstrap/esm/Button.js
var Button = __webpack_require__(35005);
// EXTERNAL MODULE: ./hooks/useZipmeLink.tsx
var useZipmeLink = __webpack_require__(98196);
// EXTERNAL MODULE: ./utils/helpers.ts + 1 modules
var helpers = __webpack_require__(32866);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
;// CONCATENATED MODULE: ./components/ApplicationWeek/Applicationweekheadr.tsx












const Appliactionweekheader = ({ data , jotformId , externalLink  })=>{
    const { zipmeLink , generateLink  } = (0,useZipmeLink/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)((head_default()), {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                    rel: "preload",
                    as: "image",
                    href: data?.mainImageUrl?.imageUrl || "/images/admissionsday/university_logoImage.svg",
                    imageSrcSet: `${(0,helpers/* getMobileImageUrl */.w9)(data?.mainImageUrl?.imageUrl) || "/images/admissionsday/university_logoImage.svg"} 640w`,
                    imageSizes: "(max-width: 767px) 640px, 100vw",
                    fetchPriority: "high"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (applicationweek_module_default()).banner,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (applicationweek_module_default()).nav,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Nav/* default */.Z, {
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                            src: data?.kcImageUrl?.imageUrl || "/images/educationfair/kc_logo.svg",
                                            width: 180,
                                            height: 45,
                                            className: (applicationweek_module_default()).navLogo,
                                            alt: data?.kcImageUrl?.alt
                                        })
                                    })
                                })
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: (applicationweek_module_default()).maincontent,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Row/* default */.Z, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "d-block d-sm-none text-center mb-4",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                            xl: 6,
                                            lg: 6,
                                            md: 12,
                                            xs: 12,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (applicationweek_module_default()).bannerStudDiv,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (applicationweek_module_default()).bg,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                        src: (0,helpers/* getMobileImageUrl */.w9)(data?.mainImageUrl?.imageUrl) || "/images/admissionsday/university_logoImage.svg",
                                                        width: 567,
                                                        height: 427,
                                                        className: (applicationweek_module_default()).cardImg,
                                                        layout: "responsive",
                                                        alt: data?.mainImageUrl?.alt
                                                    })
                                                })
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                        xl: 6,
                                        lg: 6,
                                        md: 7,
                                        xs: 12,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: (applicationweek_module_default()).fairdetails,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: (applicationweek_module_default()).heading,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("h1", {
                                                            style: {
                                                                color: data?.titleColor || "#fff"
                                                            },
                                                            children: [
                                                                data?.titleLineOne,
                                                                " ",
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("br", {}),
                                                                " ",
                                                                data?.titleLineTwo
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                                            style: {
                                                                color: data?.subTitleColor || "#fff"
                                                            },
                                                            children: [
                                                                " ",
                                                                data?.subTitle
                                                            ]
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("ul", {
                                                            className: (applicationweek_module_default()).ulli,
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                                    style: {
                                                                        color: data?.pointsColor || "#fff"
                                                                    },
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                                            src: data?.dateImageUrl,
                                                                            width: 26,
                                                                            height: 26,
                                                                            alt: "dateicon.png"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            children: data?.dateText
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                                    style: {
                                                                        color: data?.pointsColor || "#fff"
                                                                    },
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                                            src: data?.timeImageUrl,
                                                                            width: 26,
                                                                            height: 26,
                                                                            alt: "timeicon"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            children: data?.timeText
                                                                        })
                                                                    ]
                                                                }),
                                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("li", {
                                                                    style: {
                                                                        color: data?.pointsColor || "#fff"
                                                                    },
                                                                    children: [
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                                            src: data?.locationImageUrl,
                                                                            width: 26,
                                                                            height: 26,
                                                                            alt: "addressicon"
                                                                        }),
                                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                                            children: data?.locationText
                                                                        })
                                                                    ]
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (applicationweek_module_default()).regBtn,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                        onClick: ()=>{
                                                            !jotformId && generateLink(externalLink);
                                                        },
                                                        className: `${(applicationweek_module_default()).btnReg}${jotformId ? ` ${(0,helpers/* isFrappeOrJotFormClass */.gd)(jotformId)}` : ""}`,
                                                        children: "Register Now"
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                        xl: 6,
                                        lg: 6,
                                        md: 5,
                                        xs: 12,
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "d-none d-sm-block text-center mb-4",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (applicationweek_module_default()).bannerStudDiv,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (applicationweek_module_default()).bg,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                        src: data?.mainImageUrl?.imageUrl || "/images/admissionsday/university_logoImage.svg",
                                                        width: 567,
                                                        height: 427,
                                                        className: (applicationweek_module_default()).cardImg,
                                                        layout: "responsive",
                                                        alt: data?.mainImageUrl?.alt
                                                    })
                                                })
                                            })
                                        })
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var Applicationweekheadr = (Appliactionweekheader);

// EXTERNAL MODULE: ./styles/educationFair.module.scss
var educationFair_module = __webpack_require__(21174);
var educationFair_module_default = /*#__PURE__*/__webpack_require__.n(educationFair_module);
;// CONCATENATED MODULE: ./components/ApplicationWeek/Futureredaysection.tsx








const FuturereadySection = ({ eventData  })=>{
    const { zipmeLink , generateLink  } = (0,useZipmeLink/* default */.Z)();
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (educationFair_module_default()).accomplishSection,
        style: {
            background: `linear-gradient(0deg, ${eventData?.futureReadySection?.sectionBgColorBottom || "#EEF2FB"} 50%, ${eventData?.futureReadySection?.sectionBgColorTop || "#ffffff"} 0)`
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (educationFair_module_default()).studentFooter,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: (educationFair_module_default()).session,
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                        style: {
                                            color: eventData?.titleTextColor || "#fff"
                                        },
                                        children: eventData?.futureReadySection?.sectionTitle
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (educationFair_module_default()).anchor,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                        onClick: ()=>{
                                            !eventData?.meta?.jotforms[0]?.jotformid && generateLink(eventData?.externalLink);
                                        },
                                        className: `btn btn-primary   ${eventData?.meta?.jotforms[0]?.jotformid ? ` ${(0,helpers/* isFrappeOrJotFormClass */.gd)(eventData?.meta?.jotforms[0]?.jotformid)}` : ""}`,
                                        children: "Register Now"
                                    })
                                })
                            ]
                        })
                    })
                })
            })
        })
    });
};
/* harmony default export */ var Futureredaysection = (FuturereadySection);

// EXTERNAL MODULE: ./styles/countryadmissionsday.module.scss
var countryadmissionsday_module = __webpack_require__(83157);
var countryadmissionsday_module_default = /*#__PURE__*/__webpack_require__.n(countryadmissionsday_module);
// EXTERNAL MODULE: ./node_modules/react-slick/lib/index.js
var lib = __webpack_require__(46066);
// EXTERNAL MODULE: ./node_modules/slick-carousel/slick/slick.css
var slick = __webpack_require__(98322);
// EXTERNAL MODULE: ./node_modules/slick-carousel/slick/slick-theme.css
var slick_theme = __webpack_require__(98745);
// EXTERNAL MODULE: ./utils/constants.ts
var constants = __webpack_require__(59830);
;// CONCATENATED MODULE: ./components/ApplicationWeek/Toprankeduniversities.tsx












const Toprankeduniversity = ({ toprankdata  })=>{
    const sliderRef = (0,react.useRef)(null);
    const settings = {
        infinite: true,
        arrows: false,
        speed: constants/* sliderSpeed.desktopSpeed */.Y$.desktopSpeed,
        slidesToShow: 1,
        slidesToScroll: 1,
        rows: 3,
        slidesPerRow: 4,
        autoplay: true,
        autoplaySpeed: constants/* sliderSpeed.desktopAutoplaySpeed */.Y$.desktopAutoplaySpeed,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    rows: 3,
                    slidesPerRow: 3,
                    arrows: false
                }
            },
            {
                breakpoint: 768,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    rows: 2,
                    slidesPerRow: 2,
                    dots: true
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    rows: 2,
                    slidesPerRow: 2,
                    dots: true,
                    autoplaySpeed: constants/* sliderSpeed.mobileAutoplaySpeed */.Y$.mobileAutoplaySpeed
                }
            }
        ]
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: (countryadmissionsday_module_default()).popularcourses,
            style: {
                backgroundColor: toprankdata?.sectionBgColor || "#FFF1EF"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (countryadmissionsday_module_default()).heading,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                        children: toprankdata?.sectionTitle
                                    }),
                                    toprankdata?.sectionDescription && /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                        children: toprankdata?.sectionDescription
                                    })
                                ]
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                        className: "sliderComponent",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Row/* default */.Z, {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: (applicationweek_module_default()).popularCourseslider,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, {
                                        ...settings,
                                        className: (applicationweek_module_default()).slider,
                                        ref: sliderRef,
                                        children: toprankdata?.universityImages?.length > 0 && toprankdata?.universityImages?.map((universityImage, ind)=>{
                                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Col/* default */.Z, {
                                                xl: 6,
                                                sm: 12,
                                                xs: 6,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: (applicationweek_module_default()).mainBox,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: (applicationweek_module_default()).box,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                            className: (applicationweek_module_default()).img,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                                src: universityImage?.imageUrl || "/images/admissionsday/popularstart.png",
                                                                width: 223,
                                                                height: 88,
                                                                className: (applicationweek_module_default()).studImg,
                                                                alt: universityImage?.imageAltTag
                                                            })
                                                        })
                                                    })
                                                })
                                            }, ind);
                                        })
                                    }),
                                    toprankdata?.universityImages?.length > 12 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: (countryadmissionsday_module_default()).arrowsClass,
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (countryadmissionsday_module_default()).btcircle,
                                                onClick: ()=>sliderRef?.current?.slickPrev(),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                    src: "/new-images/left-arrow.svg",
                                                    height: 17,
                                                    width: 10,
                                                    alt: "left-arrow"
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: (countryadmissionsday_module_default()).btcircle,
                                                onClick: ()=>sliderRef?.current?.slickNext(),
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomImage/* default */.Z, {
                                                    src: "/new-images/right-arrow.svg",
                                                    height: 17,
                                                    width: 10,
                                                    alt: "right-arrow"
                                                })
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var Toprankeduniversities = (Toprankeduniversity);

;// CONCATENATED MODULE: ./components/ApplicationWeek/LandingPageComponent.tsx
















const LandingPageComponent = (props)=>{
    const eventData = props.pageData[0];
    (0,react.useEffect)(()=>{
        const customStyle = document.documentElement.style;
        customStyle.setProperty("--event-bgcolor", eventData?.bannerSection?.sectionBgColor || "#6C48F0");
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            props.pageData?.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(MetaTagsComp/* MetaTagsComp */.r, {
                ...props.pageData[0].meta
            }),
            eventData?.bannerSection && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Applicationweekheadr, {
                    data: eventData?.bannerSection,
                    jotformId: eventData?.meta?.jotforms[0]?.jotformid,
                    externalLink: eventData?.externalLink
                })
            }),
            eventData?.benefitsSection && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BenefitsOfAdmissionsDay/* default */.Z, {
                    benefitdata: eventData?.benefitsSection
                })
            }),
            eventData?.topRankedSection && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Toprankeduniversities, {
                    toprankdata: eventData?.topRankedSection
                })
            }),
            eventData?.popularCourses && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PopularCourses/* default */.Z, {
                    coursedata: eventData?.popularCourses
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Futureredaysection, {
                eventData: eventData
            }),
            eventData?.whyStudySection && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(WhyStudyinCountry/* default */.Z, {
                    whystudydata: eventData?.whyStudySection,
                    jotformId: eventData?.meta?.jotforms[0]?.jotformid,
                    externalLink: eventData?.externalLink
                })
            }),
            eventData?.whyChooseKc && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(eduFairWhyChoosekc["default"], {
                    data: eventData?.whyChooseKc
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(AccomplishSection/* default */.Z, {
                eventData: eventData
            }),
            eventData?.studentsSaySection && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: {
                    background: eventData?.studentsSaySection?.sectionBgColor || "#EEF2FB"
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(eduFairStudTestimonials["default"], {
                    data: eventData?.studentsSaySection
                })
            }),
            eventData?.kcNumbersSection && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(eduFairKcByNumber["default"], {
                    data: eventData?.kcNumbersSection
                })
            }),
            eventData?.faqSection && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(StudiesFAQ["default"], {
                    faqdata: eventData?.faqSection
                })
            }),
            eventData?.footer && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(eduFairFooter/* default */.Z, {
                    data: eventData?.footer,
                    jotformId: eventData?.meta?.jotforms[0]?.jotformid,
                    externalLink: eventData?.externalLink
                })
            })
        ]
    });
};
/* harmony default export */ var ApplicationWeek_LandingPageComponent = (LandingPageComponent);


/***/ }),

/***/ 76932:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"banner":"applicationweek_banner__kkBRB","nav":"applicationweek_nav__XSi6F","navLogo":"applicationweek_navLogo__bRbcd","maincontent":"applicationweek_maincontent__9tPf9","fairdetails":"applicationweek_fairdetails__9zVQG","heading":"applicationweek_heading__62oAd","ulli":"applicationweek_ulli___EgXe","regBtn":"applicationweek_regBtn__XgChb","btnReg":"applicationweek_btnReg__9_V9Z","bannerStudDiv":"applicationweek_bannerStudDiv__pSmho","bg":"applicationweek_bg__89xrh","popularCourseslider":"applicationweek_popularCourseslider__M5ED8","mainBox":"applicationweek_mainBox__CBpny","box":"applicationweek_box__1wOWO","img":"applicationweek_img__NogX6"};

/***/ })

}]);